import React from 'react';
import classNames from 'classnames';

const InputWithLabel = ({label, id, values, error, className, ...rest}) => {
    return (<div className={classNames('mb-15 w-100 container-text', {"text-danger": error})}>
        {label && <label className='label-component'>
            {label}
        </label>}
        <input id={id} name={id} value={values?.hasOwnProperty(id) ? values[id] : ""} type="text"
               className={classNames("input-text", {"is-invalid": error}, className)} {...rest} />
        {error && <div className="invalid-feedback">{error}</div>}
    </div>);
};

export default InputWithLabel;